<template>
    <li class="list-group-item pb-0 drop-down-hover">
        <div class="d-flex justify-content-between align-items-center mb-2">
            <div class="text-sm text-gray-700 d-flex align-items-center leading-none">
                <div class="rounded-circle circle-cropped avatar-xs mr-1">
                    <img class="img-fluid" :src="note.user.photo_url">
                    </div>
                {{note.user.display_name}} <span class="ml-1 text-gray-500">{{ moment(note.created_at).format('MMM D, YYYY') }}</span>
            </div>   

            <div class="drop-down dropleft">
                <a href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" data-test="noteContextMenu">
                    <i class="far fa-ellipsis-h text-xl"></i>
                </a>
                <div class="dropdown-menu py-0" aria-labelledby="dropdownMenuLink">
                    <a class="dropdown-item" @click="startEditing()" data-test="editNote">Edit Note</a>
                    <a class="dropdown-item" @click="deleteNote()" data-test="deleteNote">Delete Note</a>
                </div>
            </div>
        </div>
             
        <div v-if="state === 'default'" v-html="note.body" /> 

        <div v-if="state === 'editing'">
            <vue-editor 
                :editor-toolbar="config.editor.toolbar"
                v-model="data.body"
                data-test="editNoteBody"
            />
            <div class="form-group text-right mt-3">
                <button class="btn btn-ghost-secondary" @click="resetEdit" data-test="cancelEditButton">Cancel</button>
                <button class="btn btn-primary" @click="saveEdit" data-test="saveEditButton">Save</button>
            </div>  
        </div>
               
    </li>
</template>


<script>
    import { mapState } from 'vuex';

    export default {
        props: ['note'],

        data() {
            return {
                state: 'default',
                data: {
                    body: this.note.body
                },                
                notes: [],               
            }
        },

        methods: {
            startEditing() {
                this.state = 'editing';
            },

            resetEdit() {
                this.state = 'default';
                this.data.body = this.note.body;
            },
            saveEdit() {
                this.state = 'default';
                this.$emit('note-updated', {
                    'id': this.note.id,
                    'body': this.data.body,
                    'noteable_id': this.note.noteable_id,
                    'noteable_type': this.note.noteable_type,
                });
            },
            deleteNote() {
                this.$emit('note-deleted', {
                    'id': this.note.id,
                });
            }
        },

        computed: mapState(['config'])       
    }
</script>